import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useUser } from "../context/UserContext";
import { useCart } from "../context/CartContext";
import "../styles/main.css";

// Example ordered items (replace with your actual order state/props)
const Checkout = () => {
  const { user } = useUser();
  const { cart, clearCart } = useCart();
  const navigate = useNavigate();

  const [orderInfo, setOrderInfo] = useState(null);

  async function placeOrder() {
    const items = cart;
    try {
      const response = await fetch("http://localhost:8000/orders", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_id: user.id,
          items,
          total,
        }),
      });
      const data = await response.json();
      setOrderInfo(data.order);
    } catch (err) {
      alert("Failed to place order.");
    }
  }

  

  // Calculate total and total items
  const total = (cart || []).reduce(
    (sum, item) => sum + (item.price || 0) * (item.quantity || 0),
    0
  );
  const totalItems = (cart || []).reduce((sum, item) => sum + (item.quantity || 0), 0);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #fffbe7 0%, #e0e7ff 100%)",
        fontFamily: "'Poppins', 'Inter', 'Segoe UI', Arial, sans-serif",
        padding: 0,
        margin: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <motion.section
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        style={{
          width: "100%",
          maxWidth: 900,
          margin: "5rem auto 2.5rem auto",
          background: "rgba(255,255,255,0.97)",
          borderRadius: "2.5rem",
          boxShadow: "0 8px 32px #ffd70022",
          padding: "3.5rem 2rem 2.5rem 2rem",
          position: "relative",
        }}
      >
        <motion.h1
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          style={{
            color: "#bfa100",
            fontWeight: 900,
            fontSize: "2.5rem",
            textAlign: "center",
            letterSpacing: "0.05em",
            fontFamily: "'Playfair Display', serif",
            marginBottom: "0.5rem",
            textShadow: "0 2px 12px #ffd70044",
          }}
        >
          Checkout
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1, duration: 0.7 }}
          style={{
            color: "#22223b",
            fontSize: "1.18rem",
            textAlign: "center",
            marginBottom: "2.5rem",
            lineHeight: 1.7,
            fontWeight: 500,
            maxWidth: 600,
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          Please review your royal feast before placing your order. Each dish is
          described below for your delight!
        </motion.p>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: "2.2rem",
            margin: "0 auto 2.5rem auto",
            maxWidth: 700,
          }}
        >
          {cart.length === 0 ? (
            <div style={{ color: "#d90429", fontWeight: 700, fontSize: "1.2rem" }}>
              Your cart is empty.
            </div>
          ) : (
            (cart || []).map((item, idx) => (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 + idx * 0.1, duration: 0.6 }}
                style={{
                  display: "grid",
                  gridTemplateColumns: "110px 1fr",
                  gap: "1.5rem",
                  alignItems: "center",
                  background: "rgba(255,255,255,0.93)",
                  borderRadius: "1.5rem",
                  boxShadow: "0 2px 12px #ffd70022",
                  border: "1.5px solid #f1f5f9",
                  padding: "1.2rem 1.5rem",
                }}
              >
                <img
                  src={item.image}
                  alt={item.name}
                  style={{
                    width: 100,
                    height: 100,
                    objectFit: "cover",
                    borderRadius: "1.2rem",
                    boxShadow: "0 2px 12px #ffd70022",
                  }}
                />
                <div>
                  <div style={{ fontWeight: 700, color: "#2563eb", fontSize: "1.18rem", marginBottom: "0.3rem" }}>
                    {item.name} <span style={{ color: "#bfa100", fontWeight: 600 }}>× {item.quantity}</span>
                  </div>
                  <div style={{ color: "#64748b", fontSize: "1.05rem", marginBottom: "0.5rem", lineHeight: 1.6 }}>
                    {item.description}
                  </div>
                  <div style={{ color: "#bfa100", fontWeight: 700, fontSize: "1.08rem" }}>
                    ₹{item.price} <span style={{ color: "#22223b", fontWeight: 500, fontSize: "1rem" }}>/ each</span>
                  </div>
                </div>
              </motion.div>
            ))
          )}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            marginTop: "2rem",
            marginBottom: "2.5rem",
            fontSize: "1.25rem",
            fontWeight: 700,
            color: "#bfa100",
            letterSpacing: "0.03em",
          }}
        >
          Total:{" "}
          <span
            style={{
              marginLeft: "1.2rem",
              color: "#2563eb",
            }}
          >
            ₹{total}
          </span>
        </div>

        <div style={{ textAlign: "right", color: "#64748b", fontWeight: 500 }}>
          {cart.length > 0 && (
            <span>
              {totalItems} item{totalItems > 1 ? "s" : ""} in your cart
            </span>
          )}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "1.5rem",
          }}
        >
          <motion.button
            whileHover={{
              scale: 1.07,
              background: "linear-gradient(90deg, #fffbe7 0%, #ffd700 100%)",
              color: "#bfa100",
              boxShadow: "0 0 0 4px #ffd70033",
            }}
            whileTap={{ scale: 0.97 }}
            style={{
              background: "linear-gradient(90deg, #ffd700 60%, #ffed85 100%)",
              color: "#001d4a",
              fontWeight: "bold",
              fontSize: "1.18rem",
              borderRadius: "2.5rem",
              boxShadow: "0 4px 32px #ffd70055",
              padding: "1rem 2.8rem",
              border: "none",
              transition: "background 0.2s, box-shadow 0.2s",
              letterSpacing: "0.04em",
              outline: "none",
              cursor: "pointer",
            }}
            onClick={() => navigate("/menu")}
          >
            Add More Items
          </motion.button>
          {cart.length > 0 && (
            <motion.button
              whileHover={{
                scale: 1.07,
                background: "linear-gradient(90deg, #2563eb 0%, #6ea8fe 100%)",
                color: "#fff",
                boxShadow: "0 0 0 4px #2563eb33",
              }}
              whileTap={{ scale: 0.97 }}
              style={{
                background: "linear-gradient(90deg, #2563eb 60%, #6ea8fe 100%)",
                color: "#fff",
                fontWeight: "bold",
                fontSize: "1.18rem",
                borderRadius: "2.5rem",
                boxShadow: "0 4px 32px #2563eb33",
                padding: "1rem 2.8rem",
                border: "none",
                transition: "background 0.2s, box-shadow 0.2s",
                letterSpacing: "0.04em",
                outline: "none",
                cursor: "pointer",
              }}
              onClick={() => {
                clearCart();
                alert("Order placed! Thank you for choosing Hungry King.");
                navigate("/menu");
              }}
            >
              Place Order
            </motion.button>
          )}
        </div>

        <div style={{ marginTop: "2rem", textAlign: "center" }}>
          {orderInfo && (
            <>
              <h3 style={{ color: "#ffd700" }}>Order Placed!</h3>
              <p style={{ margin: 0 }}>Order ID: {orderInfo.order_id}</p>
              <p style={{ margin: 0 }}>User: {user.name}</p>
            </>
          )}
        </div>
      </motion.section>
    </div>
  );
};

export default Checkout;
